import { render } from "./SmallDialog.vue?vue&type=template&id=6b92e66a&scoped=true"
import script from "./SmallDialog.vue?vue&type=script&lang=js"
export * from "./SmallDialog.vue?vue&type=script&lang=js"

import "./SmallDialog.vue?vue&type=style&index=0&id=6b92e66a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b92e66a"]])

export default __exports__